/**
 * This function will group items of an array into groups.
 * eg with a max of 2 per group
 * [a, b, c, d, e, f, g] -> [[a, b], [c, d], [e, f], [g]]
 *
 * @param {Array} initialArr An array to add the collection items to
 * @param {Array} reduceArr An array of items that will be grouped
 * @param {Number} maxPerGroup The maximum amount of items in each group
 * @returns {*}
 */
export default function reduceCollectionToGroups(
  reduceArr = [],
  initialArr = [],
  maxPerGroup = 1
) {
  return reduceArr.reduce((result, item) => {
    let clone = [...result];
    const lastIndex = clone.length - 1;
    const lastGroup = result[lastIndex];
    // Add to the last group until there are the max slides, otherwise
    // create a new group and populate the first slide
    if (lastGroup && lastGroup.length < maxPerGroup) {
      clone[lastIndex] = [...clone[lastIndex], item];
    } else {
      clone.push([item]);
    }
    return clone;
  }, initialArr);
}
